// import React, { useEffect } from 'react';
// import { Routes, Route, useLocation } from 'react-router-dom';
// import Lottie from 'lottie-react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/all';

import './App.css';
// import maintenanceLottie from './lotties/SiteUnderConstructionLottie.json';

// import LandingPage from './pages/LandingPage';
// import Team from './pages/Team';
// import ProductPage from './pages/ProductPage';
// import PrivacyPolicy from './pages/PrivacyPolicy';
// import Login from './pages/Login';
// import Register from './pages/Register';
// import Home from './pages/Home';
// import About from './pages/About';

// import Navbar from './components/Navbar/Navbar';
// import Navbar2 from './components/Navbar/Navbar2';
// import ProductNavbar from './components/Navbar/ProductNavbar';
// import Marquee from './components/Marquee/Marquee';
// import Footer from './components/Footer/Footer';
// import { invalidateTL } from './components/Features/FeaturesSection';
// import BlogPage from './components/AboutPage/BlogPage';
import PageRoutes from './routes/PageRoutes';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme/theme';

gsap.registerPlugin(ScrollTrigger);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <PageRoutes />
    </ThemeProvider>
  );
};

export default App;